/* eslint-disable */
import React, { useState, useEffect, useImperativeHandle } from "react";
import { FormGroup } from "reactstrap";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import CustomImageDragger from "../../../components/CustomeImageDraggerOgURL";
import { STYLES } from "config";
import { Paper } from "@mui/material";

const styles = {
  Row: { display: "flex", flexDirection: "row", gap: "15px" }
};

const Input = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "grey",
      borderWidth: 2
    },
    "&:hover fieldset": {
      borderColor: "#999"
    },
    "&.Mui-focused fieldset": {
      borderLeftWidth: 4,
      padding: "4px !important"
    }
  },
  "& input": {
    color: "grey"
  }
});

function ImagesandLinks({ ref, data, setvalue }) {
  const [sortedImages, setSortedImages] = useState([]);
  const [captions, setCaptions] = useState({});

  useEffect(() => {
    let rawImages = data?.images;

    // Fix common misformats (array, object, null)
    const imagesArray = Array.isArray(rawImages)
      ? rawImages
      : rawImages && typeof rawImages === "object"
        ? Object.values(rawImages)
        : [];

    console.log("Validated image objects:", imagesArray);

    const validImages = imagesArray
      .filter((url) => typeof url === "string")
      .map((url, index) => ({
        url,
        name: `Image${index}` // generate a unique name
      }));

    // console.log("validimages :",validImages)
    setSortedImages(validImages);
    // if (validImages.length > 0) {
    //   const fetchFiles = async () => {
    //     const fileList = await Promise.all(
    //       validImages.map((img) => urlToFile(img.url, img.name))
    //     );
    //     console.log("File list (converted to File objects):", fileList);
    //     setSortedImages(fileList.filter(Boolean)); // remove any nulls
    //   };
    //   fetchFiles();
    // }
  }, [data.images]);

  useEffect(() => {
    if (data?.ImageCaptions) {
      setCaptions(data?.ImageCaptions);
    }
  }, [data]);

  useEffect(() => {
    if (captions) {
      console.log(`Captions updated: ${JSON.stringify(captions)}`)
    }
  }, [captions]);

  // Optional: Helper to save external input like YouTube link
  const saveData = (key, value) => {
    if (typeof setvalue === "function") {
      setvalue((prev) => ({ ...prev, [key]: value }));
    }
  };

  useImperativeHandle(ref, () => ({
    isValidated() {
      let isValid = true;

      const newErrors = {};

      if (!sortedImages || sortedImages.length === 0) {
        newErrors.images = "atleast 1 image is required";
        isValid = false;
      }

      setErrors(newErrors);
      return isValid;
    }
  }));

  return (
    <>
      <Paper elevation={5} sx={{ p: 3 }}>
        <FormGroup
          style={{
            fontSize: 35,
            fontWeight: "400",
            margin: "10px 0 0 1px",
            color: "#0b042e"
          }}
        >
          <span>Gallery</span>
        </FormGroup>
        <hr style={{ color: "#0b042e" }} />
        <div className="p-6 text-gray-900">
          <h6>
            All images will be transferred to the website on publishing. This
            image is merely to identify that the listing is correct<span style={{ color: "red" }}>*</span>.
          </h6>
        </div>
        <hr style={{ color: "#0b042e" }} />

        <div className="py-12">
          <div className="mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="overflow-hidden bg-white shadow-sm sm:rounded-lg">
              <div style={{ marginBottom: 50 }}>
                {/* ✅ Updated: pass correct format to CustomImageDragger */}
                <CustomImageDragger
                  data={sortedImages}
                  setValue={setSortedImages}
                  captionsData={captions}
                  setCaptionsData={setCaptions}
                />
              </div>

              <div
                style={{
                  ...styles.Row,
                  justifyContent: "center",
                  alignItems: "center"
                }}
              >
                <Input
                  variant="outlined"
                  fullWidth
                  onChange={(value) => {
                    value.preventDefault();
                    saveData("youtube", value.target.value);
                  }}
                  value={data?.youtubeLinkId || ""}
                  type="text"
                  label="Youtube Video ID"
                />
              </div>
            </div>
          </div>
        </div>
      </Paper>
    </>
  );
}

export default ImagesandLinks;
